import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeViewSectionLocation =
    | "property_page"
    | "investment_page"
    | "homepage"
    | "rp_apartment_prices_country"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address";
export type AmplitudeSectionName =
    | "recent_searches"
    | "popular_searches"
    | "transaction_prices"
    | "data_sources"
    | "shorts"
    | "faq"
    | "articles"
    | "popular_locations"
    | "price_differences"
    | "calculator"
    | "districts_table"
    | "price_trend"
    | "glossary"
    | "address_prices"
    | "address_comparison"
    | "address_trend";

type AmplitudeSectionProduct = Record<string, string | number | null>;

interface ITrackAmplitudeViewSectionParams {
    sectionName: AmplitudeSectionName;
    location: AmplitudeViewSectionLocation;
    itemId?: number | null;
    propertyId?: number | null;
    products?: AmplitudeSectionProduct[];
}

/** Section-level impression — sent once per section per page view, when it enters the viewport. */
export const trackAmplitudeViewSection = (params: ITrackAmplitudeViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: params.sectionName,
        location: params.location,
        item_id: params.itemId ?? null,
        property_id: params.propertyId ?? null,
        ...(params.products ? {products: params.products} : {})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

export type AmplitudeViewSectionLocation =
    | "property_page"
    | "investment_page"
    | "homepage"
    | "rp_apartment_prices_country"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address";
export type AmplitudeSectionName =
    | "recent_searches"
    | "popular_searches"
    | "transaction_prices"
    | "data_sources"
    | "shorts"
    | "faq"
    | "articles"
    | "popular_locations"
    | "price_differences"
    | "calculator"
    | "districts_table"
    | "price_trend"
    | "glossary"
    | "address_prices"
    | "address_comparison"
    | "address_trend";

type AmplitudeSectionProduct = Record<string, string | number | null>;

interface ITrackAmplitudeViewSectionParams {
    sectionName: AmplitudeSectionName;
    location: AmplitudeViewSectionLocation;
    itemId?: number | null;
    propertyId?: number | null;
    products?: AmplitudeSectionProduct[];
}

/** Section-level impression — sent once per section per page view, when it enters the viewport. */
export const trackAmplitudeViewSection = (params: ITrackAmplitudeViewSectionParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: params.sectionName,
        location: params.location,
        item_id: params.itemId ?? null,
        property_id: params.propertyId ?? null,
        ...(params.products ? {products: params.products} : {})
    });
};
